import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../services/authContext';

const PrivateRoute = ({ children }) => {
  const { user, loading, token } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !token) {
      navigate('/login');
    }
  }, [loading, token, navigate]);

  if (loading) {
    return <div>Memuat...</div>;
  }

  return token ? children : null;
};

export default PrivateRoute;
